<!--
 * @Author: 王枫叶
 * @Date: 2020-10-21 16:53:48
 * @LastEditors: 王枫叶
 * @LastEditTime: 2020-12-26 15:23:06
-->
<template>
  <div class="audiobook-box">
    <!--操作栏-->
    <div class="action-bar">
   <el-select
        v-model="params.isActive"
        size="small"
        placeholder="是否激活"
        clearable
        @change="getAudiobook()"
      >
        <el-option
          v-for="item in isActiveList"
          :value="item.value"
          :label="item.label"
          :key="item.value"
        ></el-option>
      </el-select>
      <el-input
        placeholder="ID"
        size="small"
        clearable
        class="param-input"
        v-model="params.id"
        @change="getAudiobook()"
      ></el-input>  
      <el-input
        placeholder="书名"
        size="small"
        clearable
        class="param-input"
        v-model="params.title"
        @change="getAudiobook()"
      ></el-input>         
      <el-input
        placeholder="播音员"
        size="small"
        clearable
        class="param-input"
        v-model="params.anchor"
        @change="getAudiobook()"
      ></el-input>       
      <el-input
        placeholder="小说类型"
        size="small"
        clearable
        class="param-input"
        v-model="params.fType"
        @change="getAudiobook()"
      ></el-input>      
     <el-button type="primary" size="small" @click="getAudiobook()">搜索</el-button>           
     <el-button type="primary" size="small" @click="updatePrice()">一键配置</el-button>
    </div>  
    <!--数据表格-->
    <el-table
      :data="tableData" 
      style="width: 100%"
      border
      v-loading="loading"
      :height="580"
      element-loading-text="拼命加载中"
      element-loading-spinner="el-icon-loading"
      @selection-change="handleSelectionChange"
      @sort-change="handleSortChange"      
    >
      <el-table-column type="selection" align="center" ></el-table-column>
      <el-table-column
        prop="id"
        label="ID"
        align="center"
        min-width="120"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.id || '未知' }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="title" label="标题" align="center" min-width="160" fixed>
        <template slot-scope="scope">
          <span>{{ scope.row.title }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="anchor"
        label="播音员"
        align="center"
        min-width="100"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.anchor }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="totalEpisode"
        label="总集数"
        align="center"
        min-width="100"
        :sortable="'custom'"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.totalEpisode }}</span>
        </template>
      </el-table-column>      
      <el-table-column prop="cover" label="封面" align="center" min-width="190">
        <template slot-scope="scope">
          <img-load
            v-if='scope.row.cover&&scope.row.cover!==""'
            :src="imgUrl + scope.row.cover"
            :width="'140px'"
            :height="'100px'"
          />
          <span v-else>暂无图片</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="trialSet"
        label="试听集"
        align="center"
        min-width="160"
      >
        <template slot-scope="scope">
          <el-button type="success" size="mini" @click="Action(scope.row)"
            >章节详情</el-button
          >              
        </template>
      </el-table-column>
      <el-table-column
        prop="fType"
        label="小说类型"
        align="center"
        min-width="100"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.fType }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="summary"
        label="简介"
        align="center"
        min-width="100"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <span>{{ scope.row.summary }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="countPurchases"
        label="购买数"
        align="center"
        min-width="100"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.countPurchases }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="countBrowse"
        label="浏览数"
        align="center"
        min-width="100"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.countBrowse }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="countCollect"
        label="收藏数"
        align="center"
        min-width="100"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.countCollect }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="originalPrice"
        label="原价"
        align="center"
        min-width="100"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.originalPrice }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="discountPrice"
        label="优惠价"
        align="center"
        min-width="100"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.discountPrice }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="isActive"
        label="是否激上架"
        align="center"
        min-width="100"
        fixed='right'
      >
        <template slot-scope="scope">
          <span>{{ scope.row.isActive == true ? '已上架' : '已下架' }}</span>
        </template>
      </el-table-column>      
      <el-table-column
        label="操作"
        align="center"
        fixed="right"
        min-width="180"
      >
        <template slot-scope="scope">
          <el-button
            type="danger"
            size="mini"
            icon="el-icon-delete"
            @click="remove(scope.row.id)"
          ></el-button>
          <el-button type="success" size="mini" @click="myAction(scope.row)"
            >本书配置</el-button
          >                
        </template>
      </el-table-column>
    </el-table>
    <!--分页组件-->
    <el-pagination
      :page-sizes="[10, 15, 20, 50]"
      :current-page="params.pageNumber"
      :page-size="params.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
      background
      v-if="total > 10"
      @size-change="changeSize"
      @current-change="changeCurrent"
    ></el-pagination>
    <!--章节详情-->
    <detail-page
      ref="detailPage"
      @handlerChannelList="getAudiobook"
    ></detail-page>
    <!-- 一键配置-->
    <price-page
      ref="pricePage"
      @handlerChannelList="getAudiobook"
      :checkedData="checkedData"
    ></price-page>    
    <!--本书配置-->
    <unitPrice
      ref="unitPrice"
      @getAudiobook="getAudiobook"
    ></unitPrice>    
  </div>
</template>

<script>
import API from '@/api'
import detailPage from './components/detailPage'
import unitPrice from './components/unitPrice'
import baseConfig from '@/utils/serverUrlConfig'
import pricePage from './components/pricePage'
import { sortEscape } from '@/utils/global'
export default {
  data() {
    return {
      dialogVisible: false,
      loading: false,
      // 列表数据
      tableData: [],
      checkedData: [], //被勾选的数据
      price:'',
      total: 0,
      // 系统管理列表请求参数
      params: {
        pageNumber: 1,
        pageSize: 10,
        sort: [
          { sortKey: 'countPurchases',
            sortVal: 1 }
        ]             
      },
      imgUrl: baseConfig.imgUrl,
      isActiveList: [
        { label: '已上架', value: true },
        { label: '已下架', value: false },
      ],      
    }
  },
  components: {
    detailPage,
    pricePage,
    unitPrice
  },
  created() {
    this.getAudiobook()
  },
  methods: {
    // 数据排序
    handleSortChange(column) {
    if (column.order) {
        this.params.sort.map(item => {
          item.sortVal = sortEscape(column.order)
          item.sortKey = column.prop
          return item
          
        })
      this.getAudiobook()
    }},       
        // 进行数据勾选时触发事件
    handleSelectionChange(row) {
      this.checkedData = row
    },
    // 请求有声小说列表
    getAudiobook() {
      this.loading = true
      API.getAudiobook(this.params)
        .then((res) => {
          if (res.code === 200 && res.data) {
            this.tableData = res.data.list
            this.total = res.data.total
            this.price=res.data.list.map(item=>{
                return  item.contentSet.map(el=>el.price)[0]
            })[0]
          } else {
            this.tableData = []
          }
          this.loading = false
        })
        .catch(() => {
          this.loading = false
        })
    },
    // 章节详情
    Action(data) {
      this.$refs.detailPage.open(data)
    },
    //本书配置
    myAction(data) {
      this.$refs.unitPrice.open(data)
    },    
    //一键配置
    updatePrice(){
          // price=this.price
        this.$refs.pricePage.open()
    },  
    
    //删除
    remove(id) {
      this.$confirm('您确定要删除这条信息吗？', '取消提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        API.deleteAudiobook({ id: id }).then((res) => {
          if (res.code === 200) {
            this.$message({
              message: '删除成功',
              type: 'success',
            })
            this.getAudiobook()
          } else {
            this.$message.error('删除失败！')
          }
        })
      })
    },
    // 分页条数改变回掉
    changeSize(size) {
      this.params.pageSize = size
      this.getAudiobook()
    },
    // 分页页码改变回掉
    changeCurrent(pageNumber) {
      this.params.pageNumber = pageNumber
      this.getAudiobook(this.params)
    },
  },
}
</script>

<style lang="scss" scoped>
.action-bar {
  display: flex;
}
.lf_cfg {
  
  .lf_cfg_content {
    margin-top: 30px;
    display: flex;
    justify-content: space-around;
    flex-wrap: wrap;
    div {
      margin-bottom: 10px;
      span {
        color: cadetblue;
      }
      .el-button {
        background: rgba(230, 55, 101, 0.8);
        margin-left: 20px;
        span {
          color: #ffffff;
        }
      }
    }
    .btn_style {
      padding: 4px 8px;
      color: #000000;
      background: #327720;
      border: 1px solid #999999;
      border-radius: 20px;
    }
  }
}
</style>
